import { Component, OnInit, NgModule, Input } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import {
  User,
  UserType,
  AppRole,
  Location,
  UserRegistrationModel,
  HqLocationsModel,
  PostLocationsModel
} from '../models/user.model';
import { Unsubscribable as AnonymousSubscription ,  EMPTY as empty,concat } from 'rxjs';
import { AuthUserService } from '../services/appInitialization/authUser.service';
import { LookupService } from '../services/lookups/lookup.service';
import { NgForm } from '@angular/forms';
import { RegistrationService } from '../services/registration.service';
import { ReportCategory, UserReportCategory } from '../models/report.model';
import { element } from 'protractor';
//import { forEach } from '@angular/router/src/utils/collection';
import { NotifierService } from 'angular-notifier';
import { SelectItem, TreeNode } from 'primeng/api';
import { Tree } from 'primeng/Tree';



@Component({
  selector: 'app-hq-user',
  templateUrl: './hq-user.component.html',
  styleUrls: ['./hq-user.component.css']
})
export class HqUserComponent implements OnInit {
  constructor(
    private lookupService: LookupService,
    private authUser: AuthUserService,
    private authUserService: AuthUserService,
    private registrationService: RegistrationService,
    private notifier: NotifierService
  ) {}

  public hqDetails: Hq[] = [];
  displayHQLocation = false;
  displayHQCategories = false;
  //reportCategory: Location[];
  reportCategoriesdata: ReportCategory[];
  currentUser: User;
  newLocationIds: number[];
  newUserReportCategoryIds: number[] = [];
  selectedUserReportCategories: any[] = [];
  @Input()
  locations: HqLocationsModel[];
  @Input()
  userCategories: UserReportCategory[];
  userSavedCategories: UserReportCategory[];
  programArea: Location;
  reportCategoriesTree: TreeNode[];
  reportCategories: ReportCategory[] = [];
  selectedCategoryNodes: TreeNode[] = new Array<TreeNode>();
  uniqueSelectedCategoryNodes: TreeNode[] = new Array<TreeNode>();
  selectedReportCategories: ReportCategory[] = new Array<ReportCategory>();
  programAreas: Location[];
  saveStatus:boolean = false; 
  oldCategories: boolean = false;
  newCategories: boolean = false;
  showProfilesetupAlert: boolean=false;

  ngOnInit() {
    this.currentUser = this.authUser._user;
    this.newLocationIds = Array<number>();

    this.hqDetails.push(new Hq(null, null));
    this.displayHQLocation = false;

    this.lookupService.getRootLocations(this.currentUser.userType.typeName).subscribe((data: Location[]) => {
      this.programAreas = data;
 
      if(JSON.stringify(this.currentUser.userLocations)=='[]')
      {
        this.showProfilesetupAlert=true;
      }
    });

    this.lookupService.getUserCategories().subscribe((data: UserReportCategory[]) => {
      this.userSavedCategories = data;
      this.userCategories = data.sort(
        (a, b): number => {
          if (a.categoryName < b.categoryName) return -1;
          if (a.categoryName > b.categoryName) return 1;
          return 0;
        }
      );
    });
  }

  addHQDetail() {
    // new reporting Post location selection, initialize w/ null values
    this.hqDetails.push(new Hq(null, null));
  }

  showLocationDialog() {
    this.displayHQLocation = true;
    this.saveStatus = false;
    this.hqDetails = new Array<Hq>();
    this.addHQDetail();
     this.showProfilesetupAlert=false;
  }

  showCategoriesDialog() {
    this.displayHQCategories = true;
    // this.loadReportCategories();
    // this.lookupService.getParentLocation(this.locations[0].divisionId).subscribe((data: Location) => {
    //   this.programArea = data;
    //   this.lookupService.GetReportCategories(data.id).subscribe((data: ReportCategory[]) => {
    //     this.reportCategoriesdata = data.sort(
    //       (a, b): number => {
    //         if (a.categoryName < b.categoryName) return -1;
    //         if (a.categoryName > b.categoryName) return 1;
    //         return 0;
    //       }
    //     );
    //     for (let cnt = this.reportCategoriesdata.length - 1; cnt >= 0; cnt--) {
    //       var result = this.userCategories.filter(
    //         userCategory => userCategory.categoryId === this.reportCategoriesdata[cnt].id
    //       );
    //       if (result.length > 0) {
    //         this.reportCategoriesdata.splice(cnt, 1);
    //       }
    //     }
    //   });
    // });

    this.lookupService.getReportCategoryHierarchy$().subscribe(categories => {
      this.reportCategoriesTree = Array.of(categories);
      this.reportCategoriesTree[0].expanded = true;
      this.reportCategoriesTree[0].children.sort((a, b) => {
        if (a.label < b.label) return -1;
        if (a.label > b.label) return 1;
        return 0;
      });
        this.selectedCategoryNodes = new Array<TreeNode>();
        this.lookupService.getUserCategories().subscribe((data: UserReportCategory[]) => {
          this.userCategories = data;
          this.userCategories.forEach(category => {
          this.reportCategoriesTree[0].children.forEach(categoryNode => {
            if (categoryNode.children != null && categoryNode.children.length != 0) {
              categoryNode.children.forEach(child => {
                if (child.data == category.categoryId) {
                  this.selectedCategoryNodes.push(child);
                }
              });
            }
            if (categoryNode.data == category.categoryId) {
              this.selectedCategoryNodes.push(categoryNode);
            }
            });
          });
        });
      });
  }

  addHqDetail() {
    this.hqDetails.push(new Hq(null, null));
  }

  deleteHqDetail(hqDetail: Hq) {
    const i = this.hqDetails.indexOf(hqDetail);
    this.hqDetails.splice(i, 1);
  }

  deleteUserLocation(divisionId: number) {
    this.registrationService.deleteUserLocation(divisionId).subscribe(resp => {
      if (resp.ok) {
        this.lookupService.getUserLocations().subscribe(locations => {
          this.locations = locations;
          this.newLocationIds = Array<number>();
          // window.location.reload();
        });

        this.lookupService.getUserCategories().subscribe((data: UserReportCategory[]) => {
          this.userCategories = data;
        });
        this.notifier.notify('success', 'Program Area, Division and Categories deleted successfully');
          this.showProfilesetupAlert=true;
      }
    });
   
   
  }

  deleteUserReportCategory(userReportCategoryId: number) {
    this.registrationService.deleteUserReportCategory(userReportCategoryId).subscribe(resp => {
      if (resp.ok) {
        this.lookupService.getUserCategories().subscribe(usercategories => {
          this.userCategories = usercategories.sort(
            (a, b): number => {
              if (a.categoryName < b.categoryName) return -1;
              if (a.categoryName > b.categoryName) return 1;
              return 0;
            }
          );
        });
        this.notifier.notify('success', 'Category deleted successfully');
      }
    });
  }

  onChangeProgram(hqDetail: Hq, programArea) {
    this.saveStatus = false;
    hqDetail.programAreaId = programArea.id;
    this.lookupService.getChildLocations(programArea.id).subscribe((data: Location[]) => {
      hqDetail.divisions = data.sort(
        (a, b): number => {
          if (a.locationName < b.locationName) return -1;
          if (a.locationName > b.locationName) return 1;
          return 0;
        }
      );
    });
  }

  onChangeDivision(hqDetail, division) {
    hqDetail.divisionId = division.id;    
    if(division.id != null){
      this.saveStatus = true;
    }else{this.saveStatus = false;}
  }

  saveReportingStations() {
    let deleteuserlocation$;
    if (this.locations[0] != null) {
      deleteuserlocation$ = this.registrationService.deleteUserLocation(this.locations[0].divisionId);
    } else {
      deleteuserlocation$ = empty;
    }

    this.hqDetails.forEach(element => {
      this.newLocationIds.push(element.divisionId);
    });

    let adduserlocation$ = this.registrationService.addUserLocations(this.newLocationIds);

    
    let result$ = concat(deleteuserlocation$,adduserlocation$);

    result$.subscribe(resp => {
      if (resp.ok) {
        this.lookupService.getUserLocations().subscribe(locations => {
          this.locations = locations;
        });
      }
    });
    this.notifier.notify('success', 'Program Area and Division saved successfully');
    this.displayHQLocation = false;
    this.newLocationIds = new Array<number>();
    this.showProfilesetupAlert = false;
  }

  hideAddLocationDialog() {
    this.displayHQLocation = false;
   if(this.currentUser.userLocations.length <= 0)      this.showProfilesetupAlert = true;  
      
  }

  hideCategoriesDialog() {
    this.displayHQCategories = false;
    this.selectedCategoryNodes = new Array<TreeNode>();
    this.selectedReportCategories = new Array<ReportCategory>();
    this.newUserReportCategoryIds = Array<number>();
    this.selectedUserReportCategories = Array<number>();
  }

saveReportingcategories() {
    this.newUserReportCategoryIds = new Array<number>();
    this.oldCategories = false;
    this.newCategories = false;
    
    // this.selectedUserReportCategories.forEach(element => this.newUserReportCategoryIds.push(element));
    this.selectedCategoryNodes.forEach(node => {if (node.data != 1)this.newUserReportCategoryIds.push(node.data);});
    // console.log("Selected Categories ID's =====" + this.newUserReportCategoryIds);
    // console.log("Old Categories ID's =====" + JSON.stringify(this.userSavedCategories));
    // this.userSavedCategories.forEach(category => {this.newUserReportCategoryIds.forEach(newCategory => {
    //         if(newCategory == category.categoryId)
    //             this.oldCategories = true
    //         if(newCategory != category.categoryId) 
    //             this.newCategories = true
    //         // console.log("OLD Categories ID's Count INSIDE=====" + this.oldCategories);
    //         });          });
            
    this.registrationService.updateUserReportCategories(this.newUserReportCategoryIds).subscribe(resp => {
      if (resp.ok) {
        // if(this.oldCategories)
        //   this.notifier.notify('error', 'One or more Categories already exists in your Profile');
        // if(this.newCategories)
          this.notifier.notify('success', 'Categories updated successfully');

        this.lookupService.getUserCategories().subscribe(usercategories => {
          this.userCategories = usercategories.sort(
            (a, b): number => {
              if (a.categoryName < b.categoryName) return -1;
              if (a.categoryName > b.categoryName) return 1;
              return 0;
            });
        });
      }
    });
    this.displayHQCategories = false;
    this.selectedCategoryNodes = new Array<TreeNode>();
    this.newUserReportCategoryIds = new Array<number>();
    this.selectedUserReportCategories = Array<number>();
  }

}

export class Hq {
  divisions: Location[];

  constructor(public programAreaId: number, public divisionId: number) {}
}
